<template>
  <div class="logo-container">
    <img class="img-logo"
      width="200"
      :src="ecoGroupLogo" alt="">
    <img class="img-logo"
      width="250"
      :src="medsafeLogo" alt="">
  </div>
  <h1 class="auth-title">{{labels.pageHeading}}</h1>
  <h4
    v-if="showExpiredMessage">
    {{labels.expiredAndUsed}}
  </h4>
  <form class="login-form"
    @submit.prevent="login">
    <div class="field-group">
      <span>Логин</span>
      <mcw-textfield
        v-model.trim="username"
        :label="labels.loginInput"
        :helptext="labels.noticeValidation"
        type="text"
        name="login"
        id="login"
        outline
        secondary
        autocomplete="login"
      ></mcw-textfield>
    </div>
    <div class="password-wrapper field-group">
      <span>Пароль</span>
      <mcw-textfield
        v-model.trim="password"
        :label="labels.passwordInput"
        :helptext="labels.noticeValidation"
        :type="showPassword ? 'text' : 'password'"
        name="password"
        outline
        secondary
        autocomplete="current-password"
      />

      <i
        class="material-icons password-eye"
        @click="showPassword = !showPassword"
      >
        {{ showPassword ? 'visibility_off' : 'visibility' }}
      </i>
    </div>
    <div class="field-group" v-if="showTgCodeInput">
      <span>Код из Telegram</span>
      <mcw-textfield
        v-model.trim="code"
        :label="labels.codeInput"
        type="text"
        name="code"
        outline
        id="code"
        secondary
      ></mcw-textfield>
    </div>
    <mcw-button
      class='login-btn'
      type="submit"
      raised>
      {{labels.enterButton}}
      <mcw-material-icon v-if="processing" icon="autorenew" class="loader" />

    </mcw-button>
    <!-- <router-link
      to="reset-password"
      class="login-link">
      {{labels.forgetPassword}}
    </router-link> -->
  </form>
  <mcw-snackbar
    v-model="showNotice"
    :message="labels.noticeWrongPassword"
    :dismissAction="false"
  ></mcw-snackbar>
  <mcw-snackbar
    v-model="isEmpty"
    :message="labels.emptyField"
    :dismissAction="false"
  ></mcw-snackbar>
  <mcw-snackbar
    v-model="showUncorrectHashMessage"
    :message="labels.uncorrectHashMessage"
    :dismissAction="false"
  ></mcw-snackbar>
  <mcw-snackbar
    v-model="errCode"
    :message="labels.errCode"
    :dismissAction="false"
  ></mcw-snackbar>
</template>

<script>
import { mapActions } from 'vuex';
import ecoGroupLogo from '@/assets/ecosagety_logo_group_2018.png';
import medsafeLogo from '@/assets/medsafe-logo.png';

export default {
  name: 'NewPassword',
  emits: ['loginSuccess'],
  data() {
    return {
      labels: {
        pageHeading: 'Авторизация',
        loginInput: '',
        passwordInput: '',
        enterButton: 'Вход',
        noticeWrongPassword: 'Не верные данные для входа',
        forgetPassword: 'Сменить пароль',
        emptyField: 'Введите имя пользователя и пароль',
        expiredAndUsed: 'Срок действия персональной ссылки истек. Возможен вход по логину и паролю.',
        uncorrectHashMessage: 'Неверная ссылка',
        codeInput: '',
        errCode: 'Неверный код из Telegram',
      },
      username: '',
      password: '',
      code: '',
      showNotice: false,
      isEmpty: false,
      showExpiredMessage: false,
      showUncorrectHashMessage: false,
      ecoGroupLogo,
      medsafeLogo,
      processing: false,
      showTgCodeInput: false,
      errCode: false,
      showPassword: false,
    };
  },
  mounted() {
    if (this.$route.hash) {
      this.signInByHash(this.$route.hash.substr(1));
    }
  },
  methods: {
    async signInByHash(hash) {
      const hashStatus = await this.$store.dispatch('auth/checkHash', hash);
      switch (hashStatus) {
        case 1:
          this.$router.push('/new-password');
          break;
        case 2:
          this.$router.push('/unauthorized');
          break;
        case 3:
          this.isExpired = true;
          this.showExpiredMessage = true;
          break;
        case 4:
          this.isExpired = true;
          this.$router.push('/new-link');
          break;
        default:
          this.showUncorrectHashMessage = true;
          return false;
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    checkFields() {
      return this.username && this.password;
    },
    async login() {
      if (!this.checkFields) {
        this.isEmpty = true;
        return;
      }
      const userData = {
        login: this.username,
        password: this.password,
      };
      if (this.code.length) {
        userData.code = this.code;
      }
      try {
        this.processing = true;
        await this.signIn(userData);
        const login = this.$store.state.user.user.id_login;
        if (login !== 0) {
          this.$emit('loginSuccess');
        } else {
          if (this.$store.state.user.user.err === 19) {
            this.showTgCodeInput = true;
            return;
          }
          if (this.$store.state.user.user.err === 20) {
            this.errCode = true;
            return;
          }
          this.showNotice = true;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.processing = false;
      }
    },
    ...mapActions('user', ['signIn']),
  },
};
</script>

<style>
  .login-link{
    margin-top: 30px;
    cursor: pointer;
  }
  .login-form {
    /* max-width: 400px; */
    display: flex;
    flex-direction: column;
  }
  .field-group {
    margin-bottom: 0.5rem;
  }
  .auth-title {
    text-align: center;
    margin-bottom: 1rem;
  }
  .loader {
    color: #fff !important;
    animation: hourglass-rotate 1s infinite linear;
  }
  .password-wrapper {
    position: relative;
  }

  .password-eye {
    position: absolute;
    right: 12px;
    top: 63%;
    transform: translateY(-50%);
    cursor: pointer;
    opacity: 0.6;
    user-select: none;
  }

  .password-eye:hover {
    opacity: 1;
  }
  .logo-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  @keyframes hourglass-rotate {
    0%   { transform: rotate(0deg); }
    50%  { transform: rotate(180deg); }
    100% { transform: rotate(360deg); }
  }
</style>
